module.exports = __webpack_public_path__ + "static/media/settings_chat.325462e9.svg";